<script setup>
const { $ads } = useNuxtApp()
</script>

<template>
  <div>
    <div
      id="sticky_sp"
      style="
      filter: drop-shadow(-1px -1px 2px #ccc);
      width: 100%;
      position: fixed;
      bottom: 0;
      z-index: 1000;
      background-color: #fff;
      text-align: center;
      padding-top: 7px;
      padding-bottom: 7px;
      display: none;
    "
    >
      <div
        id="div-gpt-ad-sticky"
        style="display: inline-block"
      />
      <button
        style="
        position: absolute;
        top: -24px;
        right: 0;
        height: 24px;
        width: 25px;
        border-top-left-radius: 5px;
        background-color: #fff;
        font-size: 24px;
        text-align: center;
        padding: 0;
        line-height: 1em;
        border: none;
        user-select: none;
        outline: none;
        cursor: pointer;
        min-height: auto;
      "
        @click="$ads.closeSticky()"
      >
        <svg
          width="24px"
          height="24px"
        >
          <path
            d="M4.875,4.875l12.75,12.75M17.625,4.875l-12.75,12.75"
            stroke-width="3"
            stroke="#bbb"
          />
        </svg>
      </button>
    </div>

    <div
      id="sticky_pc"
      class="standby pc"
    >
      <div id="div-gpt-ad-1666850974098-0" />
      <button
        style="
        position: absolute;
        top: 0;
        right: 0;
        height: 24px;
        width: 25px;
        border-top-left-radius: 5px;
        background-color: #fff;
        font-size: 24px;
        text-align: center;
        padding: 0;
        line-height: 1em;
        border: none;
        user-select: none;
        outline: none;
        cursor: pointer;
        min-height: auto;
      "
        @click="$ads.closeSticky()"
      >
        <svg
          width="24px"
          height="24px"
        >
          <path
            d="M4.875,4.875l12.75,12.75M17.625,4.875l-12.75,12.75"
            stroke-width="3"
            stroke="#bbb"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<style scoped>
#sticky_pc {
  width: 100%;
  min-height: 50px;
  background-color: #fff;
  transform: translateY(100px);
  display: block;
  z-index: 10;
}

#sticky_pc.standby {
  position: fixed;
  text-align: center;
  display: none;
  bottom: 0;
  animation: slideIn 0.5s ease-out 1s 1 forwards;
  -webkit-animation: slideIn 0.5s ease-out 1s 1 forwards;
}

#sticky_pc.hide {
  opacity: 1;
  animation: slideOut 0.5s ease-out 0s 1 forwards;
  -webkit-animation: slideOut 0.5s ease-out 0s 1 forwards;
}

@keyframes slideIn {
  0% {
    transform: translateY(100px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slideOut {
  0% {
    transform: translateY(0);
    opacity: 1;
  }

  to {
    transform: translateY(100px);
    opacity: 0;
    display: none;
  }
}
</style>
